//
//
//
//
//
//
//
//
//
//
//
//
//


export default {
  name: 'App',
  data() {
      return {
          mourningDay: false
      }
  },
  mounted () {
        // console.log('11111111111')
        // let getUrl = window.location.href
        // if (getUrl.indexOf('http:') > -1) {
        //     let newUrl = getUrl.replace('http:', 'https:')
        //     window.location.href = newUrl
        //     console.log(getUrl.replace('http:', 'https:'))
        // }
  },
  watch:{   //监听路由变化
    $route( to , from ){ 
        if (to.name == 'Index') {
            // let data = new Date()
            // let year = data.getFullYear()
            // let month = data.getMonth() +1
            // let day = data.getDate()
            // if (year == 2021 && month == 12 && day == 13) {
                this.mourningDay = true
            // }
        }  
    }
}
}



// WEBPACK FOOTER //
// ./src/App.vue